import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const ayvens = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Waehlen Sie Ihre Marke.": "Wählen Sie Ihre Marke.",
      "Waehlen Sie Ihren Wunschort.": "Wählen Sie Ihren Wunschort.",
      hero: {
        title: "Willkommen bei der My ALD <br/> Werkstatt-Terminbuchung",
        subtitle: null,
      },
      welcomeModal: {
        title: "Sie verlassen nun die Seite von {{organization}}",
        text: "Bitte beachten Sie, dass Sie sich auf einer Website befinden, für deren Inhalt {{organization}} nicht verantwortlich ist und die Datenschutzbestimmungen von {{organization}} keine Anwendung finden.",
      },
      hint: {
        text: "Alle gezeigten Werkstätten sind offizielle ALD Partner.",
        appointmentText: `Weitere Partner stehen zur telefonischen Terminvereinbarung in der <a class="text-white" target="_blank" href='https://www.ayvens.de/werkstattpartnersuche'>Umkreissuche</a> bereit.`,
        technicalRepair: {
          inWarrantyOemHint:
            "Herstellerwerkstätten können sämtliche Arbeiten ausführen. Bei zeitkritischen Anliegen nutzen Sie gerne auch Termine bei freien Werkstätten, um Wartungsarbeiten zu terminieren.",
          inWarrantyNoOemFoundHint: `Ups, im von Ihnen gewählten Umkreis gibt es keinen Hersteller-Werkstattpartner. Bitte erweitern Sie den Suchradius oder suchen Sie über unsere <a>Homepage</a> eine geeignete Werkstatt und buchen Sie dort eigenständig Ihren Termin.`,
        },
      },
      benefits: {
        title: "Ihre Vorteile",
        "bullet-point-1": "Freie Termine direkt online buchen oder telefonisch vereinbaren",
        "bullet-point-2":
          "Die besten Werkstattpartner auf einem Blick – bewertet nach den Qualitätsstandards von {{organization}}",
        "bullet-point-3": "",
        feedbackTitle: "Feedback",
      },
      booking: {
        "please-choose-services": "Benötigte Services wählen",
        "appointment-hint":
          "Bitte beachten Sie bei Ihrer Werkstattauswahl, dass Garantiearbeiten und Rückrufaktionen nur bei Herstellerwerkstätten durchgeführt werden können.",
        moreInformation: {
          "bullet-point-1": "Ihre Buchung geht direkt in den Kalender der {{garageType}}.",
          "bullet-point-2": "Sie können ihren Termin jederzeit kostenfrei absagen.",
          "bullet-point-3": "Es ist Ihre Tank- oder Servicekarte vorzulegen.",
          "bullet-point-4":
            "Die Werkstatt informiert Sie telefonisch, sobald Sie Ihr Auto abholen können.",
          "bullet-point-5": "",
          "bullet-point-6": "",
        },
      },
      garageList: {
        filters: {
          premiumServices: {
            "additional-cost-info": "",
            "technical-repair-info": `Bitte melden Sie
                            Beschädigungen an
                            Glas und
                            Karosserie telefonisch unserer
                            Servicehotline <tel>021191358221</tel>. Einen Ayvens Partner für Reifenersatz und Reifenwechsel finden Sie <reifenwechsel>hier</reifenwechsel>.
                            Bestimmte
                            technische Reparaturen (z. B. Software-Updates, Assistenzsysteme, Nachschlüsselanfertigungen,
                            Komfortelektronik) können nicht von freien Werkstätten durchgeführt werden. Bitte vereinbaren Sie
                            hierfür einen gesonderten Termin in einer Herstellerwerkstatt.`,
          },
        },
        emptyState: {
          headline: "Bitte prüfen Sie Ihre Suchkriterien.",
          description: `Ups, im von Ihnen gewählten Umkreis gibt es keinen Werkstattpartner. Bitte erweitern Sie den Suchradius oder suchen Sie über die Homepage des Herstellers eine geeignete Werkstatt und buchen Sie dort eigenständig Ihren Termin.`,
          "bullet-point-1": "",
          "bullet-point-2": "",
          radiusHint:
            "Wenn Sie im Umkreis von mindestens 30 km keine Partnerwerkstatt finden, können Sie jede nächstgelegene autorisierte Vertragswerkstatt nutzen.",
        },
      },
      hotline: {
        "hotline-headline": "",
        "hotline-phone-link": "tel:+4921191358221",
        "hotline-phone": "+49 211 9135 8221",
        "hotline-availability": "",
        "hotline-via-email": "",
        "hotline-via-email-email": "",
      },
      layout: {
        backText: "Zurück zu aldautomotive.de",
      },
      homeStep: {
        pleaseUseDifferentSearch: `Wir konnten für Ihre Suchkriterien aktuell keine Werkstätten mit Onlineterminvereinbarung finden.
                                                Bitte nutzen Sie die <a target="_blank" href='https://www.ayvens.de/werkstattpartnersuche'>Umkreissuche für Werkstattpartner</a> auf der ALD Website.`,
      },
      linkToHome: "https://werkstatt.repareo.de/partner/myald",
      contactForm: {
        headline: "Fast geschafft!",
        "sub-headline": "Wie erreichen wir Sie?",
        "address-label": "Wo soll das Auto abgeholt und wieder hingebracht werden?",
        "mileage-label": "Kilometerstand",
        "number-plate-label": "Wie lautet Ihr KFZ-Kennzeichen?*",
        "message-label-required":
          "Bitte teilen Sie der {{garageType}} mit, welches Anliegen Sie haben:*",
        "message-label": "Möchten Sie der {{garageType}} noch etwas mitteilen?",
        "slot-out-of-stock":
          "Ihr gewünschter Termin ist leider inzwischen vergriffen. Bitte suchen Sie sich einen neuen Termin aus.",
        activeInquiryExistsForNumberplateErrorMessage:
          "Sie haben bereits einen Termin für diesen Service und dieses Fahrzeug gebucht. Um fortzufahren, müssen Sie erst Ihren alten Termin stornieren. Stornieren können Sie über einen Link in Ihrer E-Mail zur Auftragsbestätigung oder telefonisch bei repareo unter +49 89 244 182 010.",
        activeInquiryExistsForNumberplateAndServiceErrorMessage:
          "Sie haben bereits einen Termin für diesen Service und dieses Fahrzeug gebucht. Um fortzufahren, müssen Sie erst Ihren alten Termin stornieren. Stornieren können Sie über einen Link in Ihrer E-Mail zur Auftragsbestätigung oder telefonisch bei repareo unter +49 89 244 182 010.",
        submit: "Terminbuchung abschließen",
        submitting: "Anfrage wird gesendet...",
        "mandatory-field-notice": "*Pflichtangaben",
        marketing:
          "Ich möchte Neuigkeiten, Angebote und Aktionen von repareo via Email erhalten. Widerruf jederzeit möglich.",
        adac: "Ich bin ADAC Mitglied und  möchte an der ADAC 3 % Cashback-Action teilnehmen",
        "adac-tip":
          "Als ADAC Mitglied bekommen Sie über repareo 3 % Cashback auf Ihre Werkstatt-Rechnung (Netto). Sobald die Werkstatt eine Rechnung ausgestellt hat, senden Sie uns diese einfach per E-Mail. Wir überweisen Ihnen dann Ihr Geld.",
        "rentalCar-label": "Mietwagenkategorie*",
        placeholders: {
          "first-name": "Vorname*",
          "last-name": "Nachname*",
          email: "E-Mail*",
          phone: "Telefonnummer für Rückfragen*",
          street: "Strassenname und Hausnummer",
          postcode: "Postleitzahl",
          city: "Wohnort",
          addition: "Adresszusatz",
          message: "Anmerkungen (optional)",
          "message-required": "Anmerkungen",
        },
        validationErrors: {
          "first-name": "Bitte geben Sie Ihren Vornamen an.",
          "last-name": "Bitte geben Sie Ihren Nachnamen an.",
          email: "Bitte geben Sie eine gültige E-Mail-Adresse an.",
          phone: "Bitte geben Sie eine gültige Telefonnummer an.",
          "number-plate": "Bitte geben Sie das Kfz-Kennzeichen Ihres Fahrzeuges an.",
          mileage: "Bitte geben Sie den Kilometerstand Ihres Fahrzeuges an.",
          message: "Bitte geben Sie Ihr Anliegen an.",
          tos: "Bitte akzeptieren Sie unsere Nutzungsbedingungen und Datenschutzerklärung.",
          postcode: "Die Postleitzahl darf nur Ziffern enthalten.",
        },
        numberCheck: {
          title: "Kennzeichen korrekt?",
          text: "Bitte gehen Sie sicher, dass Ihr Kennzeichen korrekt ist: {{numberplate}}.",
        },
        benefits: {
          "benefit-1": "",
          "benefit-2": "",
        },
        vehicleReturn: {
          submit: "Terminanfrage absenden",
        },
        reviewOptIn: {
          label:
            "Ich willige ein, einmalig per E-Mail zu einer Fahrerbefragung kontaktiert zu werden zum Zweck der Qualitäts- und Serviceverbesserung. Widerruf jederzeit möglich.",
        },
      },
      summary: {
        ...de_DE_formal.translation.summary,
        "contact-us-partner":
          "Sollten Sie Fragen zu Ihrer Terminbuchung haben, können Sie uns per Telefon oder E-Mail erreichen.",
      },
      contact: {
        ...de_DE_formal.translation.contact,
        text: "Haben Sie Fragen zur Buchung?",
        email: {
          link: "mailto:service.de@ayvens.com",
          title: "service.de@ayvens.com",
        },
        phone: {
          link: "tel:004921191358221",
          title: "+49 211 91358221",
        },
        reachability: "8 - 18 Uhr | Montag - Donnerstag\n8 - 17 Uhr | Freitag",
      },
    },
  },
};
